export type GetApiCommunitiesApiResponse =
  /** status 200 OK */ ApplicationCommunityDto[];

export enum BadgeType {
  Founding = "Founding-100",
}

export type UserFromCommunityDTO = {
  telegram_id: string;
  tg_name: string;
  tg_link: string;
  rating: number;
};

export type ApplicationCommunityDto = {
  data: {
    active_users_count: number;
    invite_link: string | null;
    members_count: number;
    name: string;
    rating: number;
    telegram_group_id: string;
    users: UserFromCommunityDTO[];
  };
};

export type ApplicationBadge = {
  id: string;
  pushed?: boolean;
  title: BadgeType;
  user_id: string;
};

export type GetApiCommunitiesApiArg = void;
